// Arabic font preloads, only for a page that will render Arabic (AUTH-551).
//
// index.html preloads the two Latin faces every page uses. The Arabic
// faces are preloaded here instead, when the page language is Arabic
// (?lang=ar, or <html lang="ar">), so a Latin-only visit never downloads
// them. The paths are checked by scripts/check-fonts.mjs.
export const ARABIC_PRELOADS = [
  '/fonts/Cairo-Regular-arabic.woff2',
  '/fonts/Cairo-SemiBold-arabic.woff2',
];

function pageIsArabic() {
  try {
    const lang = new URLSearchParams(window.location.search).get('lang');
    if (lang) return lang.toLowerCase().startsWith('ar');
  } catch { /* fall through to the document language */ }
  return (document.documentElement.lang || '').toLowerCase().startsWith('ar');
}

export function preloadLocaleFonts() {
  if (typeof document === 'undefined' || !pageIsArabic()) return;
  for (const href of ARABIC_PRELOADS) {
    if (document.head.querySelector(`link[rel="preload"][href="${href}"]`)) continue;
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'font';
    link.type = 'font/woff2';
    link.href = href;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  }
}
